import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=1fa5a5ee&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"
import style0 from "./Sponsor.vue?vue&type=style&index=0&id=1fa5a5ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa5a5ee",
  null
  
)

export default component.exports